import { ArrayCondition, BoolCondition, DateCondition, Expression, Filter, NumberCondition, StringCondition } from '@fabric-ui/components';

type StringConditionIn = Required<Pick<StringCondition, 'in'>>;

export const isExpr = (f: Filter): f is { expression: Expression } => 'expression' in f;
export const isAnd = (f: Filter): f is { and: { operands: Filter[] } } => 'and' in f;
export const isOr = (f: Filter): f is { or: { operands: Filter[] } } => 'or' in f;

export const isStringConditionInExpr = (expr: Expression): expr is { stringCondition: StringConditionIn } =>
  Boolean('stringCondition' in expr && expr.fieldName && expr.stringCondition?.in);

export const isStringCondition = (expr: Expression): expr is { stringCondition: StringCondition } =>
  Boolean('stringCondition' in expr && expr.fieldName);
export const isDateCondition = (expr: Expression): expr is { dateCondition: DateCondition } =>
  Boolean('dateCondition' in expr && expr.fieldName);
export const isNumberCondition = (expr: Expression): expr is { numberCondition: NumberCondition } =>
  Boolean('numberCondition' in expr && expr.fieldName);
export const isBoolCondition = (expr: Expression): expr is { boolCondition: BoolCondition } =>
  Boolean('boolCondition' in expr && expr.fieldName);
export const isArrayCondition = (expr: Expression): expr is { arrayCondition: ArrayCondition } =>
  Boolean('arrayCondition' in expr && expr.fieldName);

export const isStringConditionExpr = (
  f: Filter
): f is {
  expression: {
    fieldName: string;
    stringCondition: StringCondition;
  };
} => isExpr(f) && isStringCondition(f.expression);
export const isDateConditionExpr = (
  f: Filter
): f is {
  expression: {
    fieldName: string;
    dateCondition: DateCondition;
  };
} => isExpr(f) && isDateCondition(f.expression);

export const isNumberConditionExpr = (
  f: Filter
): f is {
  expression: {
    fieldName: string;
    numberCondition: NumberCondition;
  };
} => isExpr(f) && isNumberCondition(f.expression);
export const isBoolConditionExpr = (
  f: Filter
): f is {
  expression: {
    fieldName: string;
    boolCondition: BoolCondition;
  };
} => isExpr(f) && isBoolCondition(f.expression);
export const isArrayConditionExpr = (
  f: Filter
): f is {
  expression: {
    fieldName: string;
    arrayCondition: ArrayCondition;
  };
} => isExpr(f) && isArrayCondition(f.expression);

export const compareFieldname = (f: { expression: Expression }, fieldName: string): boolean => f?.expression?.fieldName === fieldName;
